module.exports = __webpack_public_path__ + "img/swagger.78429129.svg";